import api from "../services/api";

export async function getTransportContainer(id) {
  return await api.get("/TransportContainer/GetEditModel", {
    params: {
      id: id,
    },
  });
}
